import { BoardConfigAdminForm } from "./board-config-admin-form";
import { BoardConfigAdminHandler } from "./board-config-admin-handler";
import { BoardConfigAdminListener } from "./board-config-admin-listener";

export class BoardConfigAdminSetup {
    public form: BoardConfigAdminForm;

    public handler: BoardConfigAdminHandler;

    public listener: BoardConfigAdminListener;

    public constructor(root: HTMLElement) {
        this.form = new BoardConfigAdminForm(root);
        this.handler = new BoardConfigAdminHandler(this.form);
        this.listener = new BoardConfigAdminListener(this.form, this.handler);
    }

    public init(): void {
        if (this.form.isInitialized()) {
            return;
        }

        this.listener.register();
        this.form.markInitialized();
    }

    public static init(scope: ParentNode = document): void {
        const root = scope instanceof HTMLElement || scope instanceof Document ? scope : document;
        const targets: HTMLElement[] = [];

        if (root instanceof HTMLElement && root.matches(".board-configs-admin")) {
            targets.push(root);
        }

        BoardConfigAdminForm.getRoots(root).forEach((node) => {
            if (node instanceof HTMLElement) {
                targets.push(node);
            }
        });

        for (const target of targets) {
            const setup = new BoardConfigAdminSetup(target);
            setup.init();
        }
    }
}
